import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../helpers';
import { store } from '../../../store/store';
import { AppContextProvider } from '../../../Services/AppContext';
import AclContextProvider from '../../Acl/Components/AclContextProvider';
import WorkplaceDoctorStatistics from './WorkplaceDoctorStatistics';

loadDOMComponent({
	selector: 'react-workplace-doctor-statistics',
	callback: ({ container }: any) => {
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider>
					<AclContextProvider>
						<WorkplaceDoctorStatistics />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
